import React from 'react';
import {
    Box,
    Stack,
} from "@mui/material";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { AdminApi } from '../../api/AdminApi';

const useMockData = false;
const getMockData = () => {
    return [
        {
            "id": 42,
            "name_zh": "可信Jumping Jack",
            "name_en": "Hoshun Jump Jack",
            "code": "hoshun_jumping_jack",
            "unit": "score",
            "stat": {
                "skill_code": "hoshun_jumping_jack",
                "participant_count": "316",
                "play_duration": "7740",
                "avg_score": "8.39873417721519",
                "max_score": "25"
            }
        },
        {
            "id": 45,
            "name_zh": "陸慶濤-舞蹈樂趣",
            "name_en": "LHT Fun to Dance",
            "code": "lht_dance",
            "unit": "score",
            "stat": {
                "skill_code": "lht_dance",
                "participant_count": "929",
                "play_duration": "23170",
                "avg_score": "202.16899892357372",
                "max_score": "414"
            }
        },
        {
            "id": 46,
            "name_zh": "英華-拳擊系統",
            "name_en": "YW Boxing System",
            "code": "yw_boxing",
            "unit": "score",
            "stat": {
                "skill_code": "yw_boxing",
                "participant_count": "1662",
                "play_duration": "39660",
                "avg_score": "256.9626955475331",
                "max_score": "712"
            }
        },
        {
            "id": 47,
            "name_zh": "鄧英喜-籃球射手",
            "name_en": "POHTY Basketball",
            "code": "pohty_basketball",
            "unit": "score",
            "stat": {
                "skill_code": "pohty_basketball",
                "participant_count": "645",
                "play_duration": "14980",
                "avg_score": "8.156589147286821",
                "max_score": "28"
            }
        },
        {
            "id": 48,
            "name_zh": "兔子跳",
            "name_en": "Bunny Hop",
            "code": "kid_bunny",
            "unit": "score",
            "stat": {
                "skill_code": "kid_bunny",
                "participant_count": "1279",
                "play_duration": "30460",
                "avg_score": "37.395621579358874",
                "max_score": "105"
            }
        }
    ];
};

const createTableDataRow = (data) => {
    return data.map(item => {
        return {
            id: item.id,
            name: item.name_zh,
            participant_count: item.stat.participant_count,
            play_duration: (item.stat.play_duration / 3600).toFixed(2), // convert to hours
            avg_score: parseFloat(item.stat.avg_score).toFixed(2),
            max_score: item.stat.max_score
        };
    });
}

export default function OrgSkillStatDashboardTable({ orgId, year, startMonth = 9 }) {
    const [tableData, setTableData] = React.useState(null);


    React.useEffect(() => {
        loadData();
    }, [orgId, year, startMonth]);




    const loadData = async () => {
        // load data from api
        // for now, use mock data
        if (useMockData) {
            let data = getMockData();

            let tableData = createTableDataRow(data);
            setTableData(tableData);
            // let chartData = createChartDataFormResult(data, mode);
            //
            // setChar  tData(chartData);
            return;
        }
        AdminApi.getSkillParticipantDataCallback(orgId, year, startMonth,
            (isSuccess, msg, result) => {
                if (isSuccess) {
                    console.debug("getOrgSkillStatListCallback: result=", result);
                    let tableData = createTableDataRow(result);
                    setTableData(tableData);
                }
            });

        // AdminApi.getMonthlyParticipantDataCallback(orgID, year, startMonth,
        //     (isSuccess, msg, result) => {
        //         if (isSuccess) {
        //             console.debug("getMonthlyParticipantDataCallback: result=", result);
        //             let chartData = createChartDataFormResult(result, mode);
        //             setChartData(chartData);
        //         }
        //     });

    }

    // const mockData = getMockData();
    // const dataRows = useMockData ? createTableDataRow(mockData) : [];
    // const dataRows = [
    //     {
    //         id: 48,
    //         name: "兔子跳",
    //         participant_count: 1279,
    //         play_duration: 1.3,
    //         avg_score: 37.39,
    //         max_score: 105
    //     },
    //     {
    //         id: 42,
    //         name: "可信Jumping Jack",
    //         participant_count: 316,
    //         play_duration: 7.74,
    //         avg_score: 8.40,
    //         max_score: 25
    //     }
    // ];

    if (!tableData) {
        return <Box>Loading...</Box>;
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>運動名字</TableCell>
                        <TableCell align="right">參與人次</TableCell>
                        <TableCell align="right">遊玩時長&nbsp;(小時)</TableCell>
                        <TableCell align="right">平均分數</TableCell>
                        <TableCell align="right">最高分數</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row) => (
                        <TableRow
                            key={row.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell align="right">{row.participant_count}</TableCell>
                            <TableCell align="right">{row.play_duration}</TableCell>
                            <TableCell align="right">{row.avg_score}</TableCell>
                            <TableCell align="right">{row.max_score}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}